// extracted by mini-css-extract-plugin
export var disclosureSection = "Toggle-module--disclosureSection--480de";
export var disclosuresLink = "Toggle-module--disclosuresLink--73bfe";
export var expanded = "Toggle-module--expanded--879c3";
export var subhead = "Toggle-module--subhead--7b3b0";